import styled, { css } from 'styled-components';
import BREAK_POINTS from '../styling/media-queries';

export const Heading1 = styled.h1`
  font-weight: bold;
  font-size: 32px;
  line-height: 1;
  margin: 0;

  @media ${BREAK_POINTS.tablet} {
    font-size: 40px;
  }

  @media ${BREAK_POINTS.desktop} {
    font-size: 60px;
  }
`;

export const Heading2 = styled.h2`
  font-weight: bold;
  color: #1b1b1b;
  line-height: 1;
  font-size: 28px;
  margin: 0;

  @media ${BREAK_POINTS.mobileBig} {
    font-size: 36px;
  }

  @media ${BREAK_POINTS.desktop} {
    font-size: 40px;
  }
`;

export const Heading3 = styled.h3`
  font-size: 22px;
  line-height: 1;

  @media ${BREAK_POINTS.mobileBig} {
    font-size: 24px;
  }
`;

export const Heading4 = styled.h4`
  line-height: 1;
  font-size: 24px;
  color: #1b1b1b;

  @media ${BREAK_POINTS.mobileBig} {
    font-size: 26px;
  }

  @media ${BREAK_POINTS.desktop} {
    font-size: 28px;
  }
`;

export const TopSubhead = styled.div`
  font-weight: bold;
  letter-spacing: 0.02em;
  line-height: 1;
  font-size: 14px;
`;

export const Subtitle = styled.div`
  line-height: 1;
  font-size: 20px;

  @media ${BREAK_POINTS.desktop} {
    font-size: 22px;
  }
`;

const BodyStyle = css`
  font-size: 16px;
  line-height: 20px;
`;

export const BodyText = styled.div`
  ${BodyStyle}
`;

export const ListText = styled.li`
  ${BodyStyle}
`;

export const Detail = styled.div`
  line-height: 1;
  font-size: 14px;

  @media ${BREAK_POINTS.desktop} {
    font-size: 18px;
  }
`;

export const FinePrint = styled.div`
  line-height: 1;
  font-size: 12px;
  color: #4f4f4f;
`;

export const Link = styled.a`
  font-weight: 600;
  text-decoration-line: underline;
  color: ${(props) => props.theme.colors.primaryAccent};
`;

export const FormLabel = styled.label`
  font-weight: 600;
  line-height: 22px;
  font-size: 16px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.primaryAccent};
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Typography.tsx